import { combineReducers } from 'redux';

import { dashboardReducer } from 'src/store/Dashboard/reducer';
import { AuthReducer, AirbnbAuthReducer } from 'src/store/Auth/reducer';
import { apiReducer } from 'src/store/Api';

export const rootReducer = combineReducers({
  dashboard: dashboardReducer,
  auth: AuthReducer,
  airbnbAuth: AirbnbAuthReducer,
  api: apiReducer,
});
